// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ actions
const gapAccessActions = require('actions/contactCenter/gapAccess/gapAccess');
const raiseToN2Actions = require('actions/contactCenter/raiseToN2/raiseToN2');
const translationsActions = require('actions/translations');
const { requestFlagBasedFeatures } = require('actions/flagBasedFeatures');
const profileActions = require('actions/profile');

// @ components
const GapAccessView = require('components/contactCenter/gapAccess/gapAccessView');

class GapAccessViewContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { requestProfile, requestFlagBasedFeatures, history } = this.props;
        requestProfile(history);
        requestFlagBasedFeatures();
    }

    render() {
        return (
            <GapAccessView {...this.props} />
        );
    }
}

GapAccessViewContainer.propTypes = {
    immGapAccess: PropTypes.object.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setOperative: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    resetWizard: PropTypes.func.isRequired,
    resetRaiseN2: PropTypes.func.isRequired,
    requestTranslations: PropTypes.func.isRequired,
    immTranslations: PropTypes.object.isRequired,
    immFeatureFlags: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    requestFlagBasedFeatures: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
}

module.exports.constructor = GapAccessViewContainer;
module.exports.GapAccessViewContainer = withRouter(connect(
    state => ({
        immGapAccess: state.gapAccess,
        immRaiseToN2: state.raiseToN2,
        immTranslations: state.translations,
        immFeatureFlags: state.flagBasedFeatures,
    }),
    {
        setVisibleStep: gapAccessActions.setVisibleStep,
        setOperative: gapAccessActions.setOperative,
        validateStep: gapAccessActions.validateStep,
        resetWizard: gapAccessActions.resetWizard,
        handleFinish: gapAccessActions.handleFinish,
        resetRaiseN2: raiseToN2Actions.raiseToN2Reset,
        requestTranslations: translationsActions.requestTranslations,
        requestProfile: profileActions.requestProfile,
        requestFlagBasedFeatures,
    }
)(GapAccessViewContainer));
